import {ToastModel} from '@syncfusion/ej2-notifications';
import {MicroserviceError} from '../../interceptors/error-infos';


export class ToastDetailedErrorModel implements ToastModel {
  width = "400px";
  timeOut = 0;
  readonly cssClass = 'is-error-detailed';
  icon = 'icon-error';
  showCloseButton: true;
  title: string;

  constructor(public content: string, title?: string, public details?: MicroserviceError, iconCss?: string) {
    if (iconCss) {
      this.icon = iconCss;
    }

    if (title) {
      this.title = title;
    }
  }
}
